export default "__VITE_ASSET__f2c52c61__"